import { LocaleHelper } from "../../../../lib/locale/LocaleHelper";
import { componentsLocales as en_GB } from "../locales/en";
import { componentsLocales as ru_RU } from "../locales/ru";
export * from "../types";
export var SelectLocaleHelper = new LocaleHelper({
  ru_RU: ru_RU,
  en_GB: en_GB
});